import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { BannerListViewModel } from '../shared/models/banner-list-view-model';
import { SettingsService } from '../shared/services/settings.service';

@Component({
  selector: 'app-ads-tab',
  templateUrl: './ads-tab.component.html',
  styleUrls: ['./ads-tab.component.less'],
  standalone: false,
})
export class AdsTabComponent implements OnInit {
  private sub: Subscription;
  public bannersModel: BannerListViewModel;
  public tabIndex: number;
  public positionId: number;

  constructor(
    private route: ActivatedRoute,
    private settingsService: SettingsService
  ) {}

  ngOnInit() {
    this.sub = this.route.params.subscribe((p) => {
      this.positionId = +p['id'];
      this.onLoadBannerData(this.positionId);
    });
  }

  public onLoadBannerData(positionId: number) {
    this.settingsService
      .loadBannerListByPosition(positionId)
      .subscribe((data) => {
        this.bannersModel = data;
      });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
